import { render, staticRenderFns } from "./VCGMigrationResetPassword.vue?vue&type=template&id=04e55777"
import script from "./VCGMigrationResetPassword.vue?vue&type=script&lang=js"
export * from "./VCGMigrationResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports